import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute,Params  } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';

import{ ChangePasswordService } from './../../_services/changePassword.service';
@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangepasswordComponent implements OnInit {
  public addeditque: FormGroup;
  errorMessage: string;
  submitted = false;
  passwordvalidatio:string;
  publicorgname:any

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: MatSnackBar,
    private changepassword:ChangePasswordService) { }

  ngOnInit() {
/*
    let actorganistion = JSON.parse(localStorage.getItem('actorganistion'));
    this.publicorgname=actorganistion.org_name
*/
this.addeditque = this.formBuilder.group({
  currentpassword:'',
  newpassword:'',
  confirmPassword:''
})
  }


  onSubmit(formValue: any) 
  {
  
    if(formValue.confirmPassword==formValue.newpassword)
  {
    //console.log("formValue",formValue)   
    //currentpassword
    this.changepassword.getchangepassword(formValue.currentpassword,formValue.confirmPassword)
      .subscribe(
         data => {
         if(data.status_code==200)
         {
  
          this.snackbar.open(data.Metadata.Message, 'close', {
            duration: 3000,
            verticalPosition:"top",
            extraClasses: ['bg-green']
          });


  //console.log("data",data)
  this.router.navigate(['/']);
         // this.passwordvalidatio=" confirmPassword not match with password"
  
         }
         else
         {
  
  
  console.log("data",data.Metadata.Message)
          //this.errorMessage=data
  //this.errorMessage=data.Metadata.Message
  this.snackbar.open(data.Metadata.Message, '', {
    duration: 2000,
    verticalPosition:"top",
    extraClasses: ['bg-red']
  }); 
  
         }
        })
  
  }
  else
  {
  
    this.snackbar.open("confirmPassword not match with password", '', {
      duration: 2000,
  });
  
  //this.passwordvalidatio=" confirmPassword not match with password"
  }
  
  }


}



// WEBPACK FOOTER //
// ./src/app/component/changepassword/changePassword.component.ts